import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { expanded: Boolean, key: String }
  static targets = ["child", "icon"]

  declare expandedValue: boolean
  declare keyValue: string
  declare childTargets: HTMLElement[]
  declare iconTarget: HTMLElement
  declare hasIconTarget: boolean

  connect() {
    if (this.keyValue) {
      const stored = localStorage.getItem(this.storageKey)
      if (stored !== null) {
        this.expandedValue = stored === "true"
      }
    }
    this.applyState()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    if (this.keyValue) {
      localStorage.setItem(this.storageKey, String(this.expandedValue))
    }
    this.applyState()
  }

  private get storageKey(): string {
    return `tree_row_${this.keyValue}`
  }

  private applyState() {
    for (const child of this.childTargets) {
      child.hidden = !this.expandedValue
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-90", this.expandedValue)
    }
  }
}
